import { createAsyncThunk } from '@reduxjs/toolkit';

import { buildSpendInsightsBody } from '../lib/buildSpendInsightsBody';

import type {
    SpendInsightsRequestParams,
    SpendInsightsSummaryDto,
} from '../types/ReportSpendSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchSpendSummary = createAsyncThunk<
    SpendInsightsSummaryDto,
    SpendInsightsRequestParams,
    ThunkConfig<string>
>('reportSpendSummary/fetchSpendSummary', async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const response = await extra.api.post<SpendInsightsSummaryDto>(
            '/v1/reports/spend-insights/summary',
            buildSpendInsightsBody(params),
        );
        return response.data;
    } catch {
        return rejectWithValue('error');
    }
});
